import { Button as BaseButton } from '@base-ui/react/button';
import { Dialog } from '@base-ui/react/dialog';
import { X } from 'shared/icons';

const widthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '4xl': 'max-w-4xl',
    '6xl': 'max-w-6xl',
};

const Modal = ({
    isOpen,
    onClose,
    title,
    icon = null,
    children,
    actions = null,
    size = 'md',
    showCloseButton = true,
    bodyClassName = '',
    contentClassName = '',
    lockScroll = true,
}) => {
    if (!isOpen) {
        return null;
    }

    const widthClass = widthClasses[size] || widthClasses.md;

    return (
        <Dialog.Root
            open={isOpen}
            modal
            onOpenChange={(open) => {
                if (!open) {
                    onClose?.();
                }
            }}
        >
            <Dialog.Portal>
                <Dialog.Backdrop className="fixed inset-0 z-50 bg-black/50" />
                <Dialog.Popup className={`fixed inset-0 z-50 ${lockScroll ? 'overflow-y-auto' : ''}`}>
                    <div className="relative min-h-full flex items-center justify-center p-4">
                        <div
                            className={`w-full ${widthClass} bg-white dark:bg-mono-950 border border-mono-200 dark:border-mono-800 rounded-xl shadow-xl-mono ${contentClassName}`}
                        >
                            <div className="flex items-center justify-between p-6 border-b border-mono-200 dark:border-mono-800">
                                <div className="flex items-center gap-3">
                                    {icon ? (
                                        <div className="p-2 bg-mono-100 dark:bg-mono-900 rounded-lg">{icon}</div>
                                    ) : null}
                                    <Dialog.Title className="text-xl font-bold text-black dark:text-white">
                                        {title}
                                    </Dialog.Title>
                                </div>

                                {showCloseButton ? (
                                    <BaseButton
                                        type="button"
                                        onClick={onClose}
                                        className="inline-flex items-center justify-center p-2 hover:bg-mono-100 dark:hover:bg-mono-900 rounded-lg transition-colors pointer-coarse:min-h-11 pointer-coarse:min-w-11"
                                    >
                                        <X size={20} className="text-mono-600 dark:text-mono-400" />
                                    </BaseButton>
                                ) : null}
                            </div>

                            <div className={`p-6 ${bodyClassName}`}>{children}</div>

                            {actions ? (
                                <div className="flex gap-3 p-6 border-t border-mono-200 dark:border-mono-800">
                                    {actions}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </Dialog.Popup>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export default Modal;
